function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.91 6.628h-2.183a.182.182 0 01-.145-.283l1.48-2.215a.729.729 0 10-1.213-.809l-1.425 2.136a.182.182 0 01-.303 0L13.696 3.32a.728.728 0 00-1.21.81l1.478 2.214a.182.182 0 01-.152.283H5.091A1.07 1.07 0 004 7.675v9.551c.013.59.5 1.058 1.09 1.047h1.333a.182.182 0 01.14.298l-.577.69a.728.728 0 101.119.932l1.545-1.855a.181.181 0 01.14-.065h6.42c.054 0 .105.024.14.065l1.545 1.855a.728.728 0 001.119-.931l-.576-.691a.182.182 0 01.14-.298h1.331A1.07 1.07 0 0020 17.226V7.675a1.07 1.07 0 00-1.09-1.047zM12 16.091a44.135 44.135 0 01-5.136-.322.364.364 0 01-.319-.363V9.5a.364.364 0 01.319-.363A44.087 44.087 0 0112 8.818c1.717.007 3.432.115 5.136.322.183.023.32.18.319.364v5.906a.364.364 0 01-.319.364 44.31 44.31 0 01-5.136.317z"
});

function SvgTvWithCable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgTvWithCable;